import React, { Component } from 'react';
import { Tooltip } from 'antd';
import { ContainerStyle, BasicTableStyle } from './../PlayerList/PlayerListStyle';

interface Props {
	t: any;
}
class PricingTable extends Component<Props> {
	constructor(props: Props) {
		super(props);
	};

	state = {};

	render() {
		const t = this.props.t;

		const data = [
			{feature: {title: t("shop.premiumAtitle"), text: ""}, free: true, premium: true},
			{feature: {title: t("shop.premiumBtitle"), text: ""}, free: true, premium: true},
			{feature: {title: t("shop.premiumCtitle"), text: ""}, free: true, premium: true},
			{feature: {title: t("shop.premiumDtitle"), text: ""}, free: true, premium: true},
			{feature: {title: t("shop.premiumItitle"), text: t("shop.premiumItext")}, free: false, premium: true},
			{feature: {title: t("shop.premiumHtitle"), text: t("shop.premiumHtext")}, free: false, premium: true},
			{feature: {title: t("shop.premiumGtitle"), text: t("shop.premiumGtext")}, free: false, premium: true},
			{feature: {title: t("shop.premiumFtitle"), text: t("shop.premiumFtext")}, free: false, premium: true},
			{feature: {title: t("shop.premiumEtitle"), text: t("shop.premiumEtext")}, free: false, premium: true},
			// {feature: {title: t("shop.premiumJtitle"), text: t("shop.premiumJtext")}, free: false, premium: true},
			// {feature: {title: t("shop.premiumKtitle"), text: t("shop.premiumKtext")}, free: false, premium: true},
		];

		const withMetaData = data.map((item: any, index: number) =>
			Object.assign({}, item, { rank: index + 1 }));

		const columns = [{
			title: t('shop.feature'),
			key: 'feature',
			dataIndex: 'feature',
			width: '50%',
			render: (text: string, record: any) => {
				let color = record.free ? '#000' : '#151820'
				return (
					<Tooltip title={record.feature.text}>
						<span style={{color: color}}>{record.feature.title}</span>
					</Tooltip>
				);
			},
		}, {
			title: t('shop.gratis'),
			key: 'free',
			dataIndex: 'free',
			width: '25%',
			render: (option: boolean, record: any) => {
				return option ? `✅` : `❌`;
			}
		}, {
			title: '$9,90',
			key: 'premium',
			dataIndex: 'premium',
			width: '35%',
			render: (option: boolean, record: any) => {
				return option ? `✅` : `❌`;
			}
		}];

		return (
			<ContainerStyle>
				<BasicTableStyle
					style={{margin: "20px 40px 0"}}
					columns={columns}
					rowKey="rank"
					dataSource={withMetaData}
					pagination={false}
					rowClassName={(record: object, index: number) => index % 2 ? 'ant-table-row--odd' : 'ant-table-row--even'}
				/>
			</ContainerStyle>
		);
	}
}

export default PricingTable;
